import { render, staticRenderFns } from "./Pishkhan.vue?vue&type=template&id=56760489&scoped=true&"
import script from "./Pishkhan.vue?vue&type=script&lang=js&"
export * from "./Pishkhan.vue?vue&type=script&lang=js&"
import style0 from "./Pishkhan.vue?vue&type=style&index=0&id=56760489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56760489",
  null
  
)

export default component.exports